import { Request } from '../../../../generic/v2/request/request';
import { UserRequestName } from '../../../user-request-name';

export abstract class UserRequest extends Request<UserRequestName> {}
